import React, { useState, useEffect } from "react";
import './App.css';

const createList = async () => {
  const tweetsUp = [[], [], []]; 

  try {
    const response = await fetch("/tweetsOutput.txt");
    const data = await response.text();
    const rows = data.split("\n");

    let time = "", user = "", tweet = "";

    rows.forEach((row) => {
      const trimmedRow = row.trim();

      if (trimmedRow.startsWith("--------------------------")) {
        if (time && user && tweet) {
          tweetsUp[0].push(time);
          tweetsUp[1].push(user);
          tweetsUp[2].push(tweet);
        }
        time = "";
        user = "";
        tweet = "";
      } else {
        if (!time) {
          time = trimmedRow;
        } else if (!user) {
          user = trimmedRow;
        } else {
          tweet += tweet ? `\n${trimmedRow}` : trimmedRow;
        }
      }
    });

    if (time && user && tweet) {
      tweetsUp[0].push(time);
      tweetsUp[1].push(user);
      tweetsUp[2].push(tweet);
    }
    return tweetsUp;

  } catch (error) {
    return [[], [], []];
  }
};


const formatTweet = (text) => {
  const regex = /@(\w+)/g; 
  return text.replace(regex, '<span class="mention">@$1</span>');
};

const App = () => {
  const [tweetsUp, setTweetsUp] = useState([[], [], []]);
  const [displayedTweets, setDisplayedTweets] = useState([]);
  const [viewMode, setViewMode] = useState("single"); 
  const [currentTweet, setCurrentTweet] = useState({ time: "", user: "", tweet: "" });
  const [profilePics, setProfilePics] = useState([]);

  useEffect(() => {
    const loadTweets = async () => {
      const loadedTweets = await createList();
      setTweetsUp(loadedTweets);
    };
    loadTweets();
  }, []);

  useEffect(() => {
    if (viewMode === "scroll") {
      const interval = setInterval(() => {
        if (tweetsUp[0].length === 0) return;
        
        const randomNumber = Math.floor(Math.random() * tweetsUp[0].length);
        const newTweet = {
          time: tweetsUp[0][randomNumber],
          user: tweetsUp[1][randomNumber],
          tweet: tweetsUp[2][randomNumber]
        };

        const gender = Math.random() < 0.5 ? 'male' : 'female';
        const newProfilePic = `https://xsgames.co/randomusers/avatar.php?g=${gender}&t=${new Date().getTime()}`;

        setDisplayedTweets(prevTweets => [...prevTweets, { ...newTweet, profilePic: newProfilePic }]);
        setProfilePics(prevPics => [...prevPics, newProfilePic]);
      }, 2000);

      return () => clearInterval(interval);
    }
  }, [viewMode, tweetsUp]);

  const handleClick = () => {
    if (tweetsUp[0].length === 0) {
      console.error("No tweets available");
      return;
    }

    const randomNumber = Math.floor(Math.random() * tweetsUp[0].length);
    setCurrentTweet({
      time: tweetsUp[0][randomNumber],
      user: tweetsUp[1][randomNumber],
      tweet: tweetsUp[2][randomNumber]
    });

    const gender = Math.random() < 0.5 ? 'male' : 'female';
    setProfilePics([`https://xsgames.co/randomusers/avatar.php?g=${gender}&t=${new Date().getTime()}`]);
  };

  const toggleViewMode = () => {
    if (viewMode === "scroll") {
      setViewMode("single");
      setDisplayedTweets([]);
    } else {
      setViewMode("scroll");
    }
  };

  return (
    <div className="app-container">
      <img
        src={"/image.webp"}
        alt="Profile"
        className="title-pic"
      />
      <div className="button-container">
        <div className="info-container">
          <div className="info-box">
            <div className="info-box-icon">help?</div>
            <div className="info-box-text">
              Ever wished to relive the golden days of early Twitter? 
              <br />
              You're in luck! This site brings you a unique visualization of tweets from 2009—a nostalgic trip through nearly one million real tweets.
              <br /><br />
              You can explore these authentic tweets in two ways: a single-tweet view or a continuous scrolling feed. 
              <br />
              Simply switch between views with the click of a button and enjoy a glimpse into Twitter's past."
            </div>
          </div>
        </div>
        <button className="toggle-view-button" onClick={toggleViewMode}>
          {viewMode === "scroll" ? "Switch to Single View" : "Switch to Scroll View"}
        </button>
        <button className="fetch-button" onClick={handleClick}>Load Single Tweet</button>
        
        
      </div>
      <div className={`tweet-container ${viewMode}`}>
        {viewMode === "scroll" ? (
          <div className="scroll-view">
            {displayedTweets.map((tweet, index) => (
              <div key={index} className="tweet">
                <img
                  src={tweet.profilePic}
                  alt="Profile"
                  className="profile-pic"
                />
                <div className="tweet-content">
                  <div className="tweet-header">
                    <span className="username">@{tweet.user}</span>
                  </div>
                  <p className="tweet-text" dangerouslySetInnerHTML={{ __html: formatTweet(tweet.tweet) }} />
                  <span className="tweet-time">{tweet.time}</span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          currentTweet.tweet ? (
            <div className="tweet">
              <img
                src={profilePics[0] || "/default-avatar.png"}
                alt="Profile"
                className="profile-pic"
              />
              <div className="tweet-content">
                <div className="tweet-header">
                  <span className="username">@{currentTweet.user}</span>
                </div>
                <p className="tweet-text" dangerouslySetInnerHTML={{ __html: formatTweet(currentTweet.tweet) }} />
                <span className="tweet-time">{currentTweet.time}</span>
              </div>
            </div>
          ) : (
            <p>Click the button to load a tweet</p>
          )
        )}
      </div>
    </div>
  );
};

export default App;
